import { NotFound } from '@/shared/ui/NotFound'

export const NotFoundPage = () => {
	return (
		<div className="container flex-1">
			<NotFound className="py-20" />
		</div>
	)
}
